import { Injectable } from '@angular/core';
import mqtt, { IClientOptions, IClientPublishOptions, IPublishPacket } from 'mqtt';

@Injectable({
  providedIn: 'root',
})
export class MqttService {
  client: mqtt.MqttClient | undefined;
  //url: string = 'mqtt://homeassistant.local:8083/mqtt'; // 'mqtt://homeassistant.local:8083/mqtt' 'ws://localhost:9001' ,{defaultProtocol:"mqtt",port:1883,path:"/mqtt"}
  //url: string = 'mqtt://homeassistant.local:1883';
  //clientId: string = 'mqttClient';
  callback: any;
  topicList: string[] = [];
  logList: string[] = [];
  opt!: IClientOptions;
  isSubscribed: boolean = false;
  constructor() { }
  //async init(hostName: string, port: number, userId: string, password: string, clientId: string, list: string[]): Promise<boolean>{
  init(opt: IClientOptions, list: string[], ip: string, callback: any): boolean {
    this.callback = callback;
    this.topicList.push(...list);
    //  this.url = opt.host;
    this.opt = opt;
    //if (opt.keepalive === 0) opt.keepalive = 60; // 設置心跳間隔為 60 秒
    if (!opt.clientId) opt.clientId = (ip); //orm.ip()
    this.connect();
    /*
    if (hostName !== '')
      this.opt.host = hostName;
    if(userId !== '')
      this.opt.username = userId;
    if(password !== '')
      this.opt.password = password;
    if (port === 0)
      this.opt.port = 1883
    else
      this.opt.port = port;
    */
    //  this.clientId = clientId;

    // list.forEach((v, i) => {
    //   this.topicList.push(v);
    // });

    /*this.client = mqtt.connect(url); //
    this.client.on('connect', () => {
      console.log('mqtt connected');
      this.client.subscribe(list);
    });*/

    //this.client = await mqtt.connectAsync(opt);
    return true;
  }
  connect() {
    this.client = mqtt.connect(this.opt);
    this.client.on('connect', () => {
      // 每1秒就 connect 一次.why?
      if (!this.isSubscribed) {
        this.isSubscribed = true;
        for (let i = 0; i < this.topicList.length; i++) {
          this.clearRetainedMessage(this.topicList[i]);
          this.mySubscribe(this.topicList[i]);
          let msg = this.opt.clientId + ' 上線!';
          this.publish(this.topicList[i], msg);
          this.logList.push(msg + ' topic:' + this.topicList[i]);
        }
      }
    });
    this.client.on('error', (err): void => {
      console.error('MQTT connection error:', err);
      if (this.client) this.client.end();
    });
    this.client.on('close', () => {
      //console.log('MQTT connection closed');
      // 重新連接邏輯
      // setTimeout(() => this.connect(), 5000); // 5 秒後重新連接
    });
    /*
    let bool = this.client.connected;
    if (bool) {
      for (let i = 0; i < list.length; i++) {
        await this.client.subscribeAsync(list[i]);
        let msg = opt.clientId + ' subscribed.';
        this.logList.push('topic:'+list[i]+' '+msg);
        await this.client.publishAsync(list[i], msg);
      }
    }else{
      let msg = "ERROR:mqtt.init not connected";
      this.logList.push(msg);
      console.error(msg);
    } */

    /*this.client.on('connect', () => {
      let msg = 'mqtt on connect: connected';
      this.logList.push(msg);
    });*/

    this.client.on('message', (topic, message, clientId: IPublishPacket) => {
      // message is Buffer
      let msg = message.toString();
      console.log(clientId);
      if (msg.includes('上線')) return;
      this.logList.push('topic:' + topic + ' message:' + msg); //console.log("receive:",topic,msg);
      if (this.callback) {
        this.callback(topic, msg);
      }
      // this.client.end();
    });
  }
  getResult(): string {
    return this.logList.join('\n');
  }
  mySubscribe(topic: string) {
    //this.jkRet.clear();
    try {
      if (this.client) {
        this.client.subscribe(topic, (err) => {
          if (err) {
            //this.ret.addResultError(err.tostring());
            console.error(topic + ' ' + err.message);
          } else {
            //this.ret.result = true;
            //this.mqttClient.publish('subscribe',this.topic);
            console.log('subscribed:', topic);
          }
        });
      }
      //logger.info('jkMqtt substribe topic:' + topic);
      //this.jkRet.result = true;
    } catch (error: any) {
      console.error(error.message);
    }
  }
  publish(topic: string, message: any) {
    try {
      if (message === '') {
        return;
      }

      let bool = this.client?.connected;
      if (!bool) {
        this.client?.reconnect(this.opt);
      }
      let opts: IClientPublishOptions;
      opts = { qos: 0, retain: false };
      this.client?.publish(topic, message, opts);
      //this.client?.publish(topic, message);
      // logger.debug('publish topic:', topic, 'message:', message)
    } catch (error: any) {
      console.error('publish topic:', topic, 'error:', error.message);
    }
  }
  clearRetainedMessage(topic: string) {
    if (this.client) {
      this.client.publish(topic, '', { retain: true }, (err) => {
        if (err) {
          console.error(`Failed to clear retained message for topic ${topic}: ${err.message}`);
        } else {
          console.log(`Cleared retained message for topic ${topic}`);
        }
      });
    } else {
      console.error('MQTT client is not connected');
    }
  }

}
